export default function Loader() {
    return <>
        <div className="flex flex-col justify-center items-center h-screen">
            <div className="rounded-full h-20 w-20 bg-violet-800 animate-ping"></div>
            <h3 className="text-2xl font-bold my-20 0 text-gray-600 mb-4" style={{ letterSpacing: '5px' }}>
                Panther Exim
            </h3>
        </div>
    </>
}